// Hari K : 20-06-2023 : BT-99161 - Breeze - funds-add funds modal-start

import { useDispatch, useSelector } from "react-redux";
import { BzButton, BzChip, BzDropdown, BzInputText, BzModal, BzModalBody, BzModalHeader, BzTextArea } from "../../components";
import { handleModal } from "../../redux/actions/modals";
import { forwardRef, memo, useEffect, useState } from "react";
import { Row, Col, Container, Dropdown } from "react-bootstrap";
import SuccessModal from './SuccessModal';
import { getAvailableBankList, getPeridiocityWiseBalance, getmappedBanksList } from "../../redux/actions/funds";
import { APPLICATION_TYPE, APP_INFO_PARAMS, FUNDS_DEFAULT_INPUT_LENGTH, PAYU, PAYTM, ATOM_VALUE_HEADER, THEME_TYPE, LOCAL_STORAGE_KEYS } from "../../utils/global_variables";
import { getAppInfoData, isGuestUser, createPGURL, setEncryptLocalStorage, getDecryptLocalStorage, getDyanmicURL } from "../../utils/global_functions";
import { _commaFormatter, _kFormatter, _validateUPIId } from "../../controllers";
import { toastConfig } from "../../redux/actions/toast";
import { _EncodeToBase64, _GetPGDownTime, _createDynamicUrl } from "../../controllers/funds";



const AddFundsModal = ({ activeMarket, setActiveMarket }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const appInfo = useSelector(state => state?.appInfo?.appInfo);
    const UPIDetails = useSelector(state => state.funds.UPIDetails);
    const bankAccList = useSelector(state => state.funds.bankAccList);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);
    const dicTrHolidayMaster = useSelector(state => state.funds.dicTrHolidayMaster);
    const productWiseBalance = useSelector(state => state.funds.allowedMarkets);
    const availableBankList = useSelector(state => state.funds.availableBankList);

    const objFundsMaxAmount = getAppInfoData(APP_INFO_PARAMS.APP_FUND_MAX_AMT, appInfo);
    const netNetUrl = getAppInfoData(APP_INFO_PARAMS.APP_NETNET_PG_URL, appInfo);
    const PGDownKeys = getAppInfoData(APP_INFO_PARAMS.APP_WAVE_SETTING, appInfo);
    const objNEFTConfig = getAppInfoData(APP_INFO_PARAMS.APP_NEFT_CONFIG, appInfo);
    const nMinAmount = getAppInfoData(APP_INFO_PARAMS.APP_ATOM_MINIMUM_AMOUNT, appInfo);
    const data = getAppInfoData(APP_INFO_PARAMS.APP_FUNDS_CONFIG, appInfo);
    const fundsConfig = Array.isArray(data) ? data[0] : data;

    const [objDowntime, setobjDowntime] = useState();
    const [arrProductWiseUPIDetails, setArrProductWiseUPIDetails] = useState();
    const [arrProductWiseBankAccounts, setArrProductWiseBankAccounts] = useState();
    const [addFundOption, setAddFundOption] = useState("");
    const [selectedBank, setSelectedBank] = useState({});
    const [addFunds, setAddFunds] = useState({ paymentGatWay: {}, isNiftTransfer: false, addAmount: 0, product: {}, netBankMode: 'holdFunds', UPIId: '' });
    const [isSatisfiedAllparameters, setIsSatisfiedAllparameters] = useState(true);
    const [maxAmount_add, setMaxAmount] = useState(0);
    const [minAmount, setMinAmount] = useState(0);
    let ModeOption = 0;
    const atomValueHeader = getAppInfoData(APP_INFO_PARAMS.PG_UPI_ATOM_VALUE_HEADER, appInfo);


    useEffect(() => {
        if (nMinAmount !== undefined && Number(nMinAmount) > 0 && Number(nMinAmount) > 50) {
            setMinAmount(parseFloat(nMinAmount));
        } else {
            setMinAmount(50);
        }
        if (addFundOption === "Net Banking") {
            if (Number(objFundsMaxAmount?.add_NB)) {
                setMaxAmount(parseFloat(objFundsMaxAmount?.add_NB));
            } else {
                setMaxAmount(parseFloat(Number.POSITIVE_INFINITY));
            }
        } else {
            if (Number(objFundsMaxAmount?.add)) {
                setMaxAmount(parseFloat(objFundsMaxAmount?.add));
            } else {
                setMaxAmount(parseFloat(Number.POSITIVE_INFINITY));
            }
        }

    }, [nMinAmount, maxAmount_add, objFundsMaxAmount, addFundOption]);


    // Hari K : 25-11-2023 : BT-99161 - Breeze - funds-add funds modal-start
    const [isUPIShow, setIsUPIShow] = useState(true);

    useEffect(() => {
        if (bankAccList && bankAccList?.length && activeMarket && Object.keys(activeMarket).length) {
            const productWiseBankDetails = bankAccList?.filter((eachAccount) => eachAccount?.nProductCode === activeMarket?.sProductId || eachAccount?.nProductCode === '0');
            const defaultSelectedBank = bankAccList?.filter((eachAccount) => eachAccount?.bDefault === true && (eachAccount?.nProductCode === activeMarket?.sProductId || eachAccount?.nProductCode === '0'));
            setArrProductWiseBankAccounts(productWiseBankDetails);
            if (!defaultSelectedBank || !defaultSelectedBank?.length) {
                setSelectedBank(productWiseBankDetails[0]);
            } else {
                setSelectedBank(defaultSelectedBank[0]);
            }
        } else {
            setArrProductWiseBankAccounts();
            setSelectedBank({});
        }
        if (UPIDetails && UPIDetails?.length > 0 && activeMarket) {
            const filteredUPIDetails = UPIDetails?.filter((eachUPI) => eachUPI?.sProductId === activeMarket?.sProductId);
            if (filteredUPIDetails?.length) {
                setIsUPIShow(true);
                setAddFundOption('UPI');
            } else {
                setIsUPIShow(false);
                setAddFundOption('Net Banking');
            }
        } else { }
    }, [UPIDetails, bankAccList, activeMarket]);


    useEffect(() => {
        if (addFunds?.addAmount > 0 && addFundOption !== "NEFT Tranfer" && (objDowntime?.IsDownTime === false || objDowntime?.IsDownTime === undefined)) {
            setIsSatisfiedAllparameters(false);
        } else if (addFundOption === "NEFT Tranfer") {
            setIsSatisfiedAllparameters(false);
        }
        else {
            setIsSatisfiedAllparameters(true);
        }
    }, [objDowntime, addFunds]);


    useEffect(() => {
        if (dicTrHolidayMaster?.length) {
            _GetPGDownTime(PGDownKeys, dicTrHolidayMaster, dispatch).then((response) => {
                setobjDowntime(response);
            });
        }
    }, [dicTrHolidayMaster]);


    useEffect(() => {
        if (addFundOption === 'Net Banking') {
            if (selectedBank && Object.keys(selectedBank)?.length && activeMarket && Object.keys(activeMarket)?.length) {
                dispatch(getmappedBanksList(activeMarket?.sProductId, selectedBank.sBankId)).then((res) => {
                    if (res?.length > 0) {
                        setArrProductWiseUPIDetails(res);
                        setAddFunds({ ...addFunds, paymentGatWay: res[0] });
                    } else {
                        setArrProductWiseUPIDetails([]);
                        setAddFunds({ ...addFunds, paymentGatWay: {} });
                    }
                });
            } else {
            }
        }
        if (addFundOption === 'UPI') {
            if (UPIDetails?.length) {
                const filteredUPIDetails = UPIDetails?.filter((eachUPI) => eachUPI?.sProductId === activeMarket?.sProductId);
                if (filteredUPIDetails?.length > 0) {
                    setArrProductWiseUPIDetails(filteredUPIDetails);
                    setAddFunds({ ...addFunds, paymentGatWay: filteredUPIDetails[0] });
                } else {
                    setArrProductWiseUPIDetails();
                    setAddFunds({ ...addFunds, paymentGatWay: {} });
                }
            }
            else { }
        }
    }, [addFundOption, selectedBank, activeMarket]);


    const handleAddTransfer = (value) => {
        if (value === "NEFT Tranfer") {
            setAddFunds({ ...addFunds, addAmount: 0 });
        } else {
            setAddFunds({ ...addFunds, addAmount: 0 });
        }
        setAddFundOption(value);
    };

    // const handleNetBanking = (value) => {
    //     setAddFunds({ ...addFunds, netBankMode: value });
    // };

    const handleOrderInputs = (amount) => {
        if (amount?.toString()?.length <= FUNDS_DEFAULT_INPUT_LENGTH.ADD_FUNDS) {
            setAddFunds({ ...addFunds, addAmount: amount });
        } else {
        }
    };

    const ClearClick = () => {
        setAddFunds({ ...addFunds, addAmount: 0 });
    };





    function payWithRazorpay(orderId, memberId, userDetails) {

        let theme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);
        var themecolor;

        if (theme == THEME_TYPE.LIGHT) {
            themecolor = '#FFFFFF';
        }
        else {
            themecolor = '#000000';
        }

        let options = {
            order_id: orderId,
            currency: "INR",
            key: memberId,
            amount: addFunds.addAmount * 100,
            name: config.Title,
            prefill: {
                email: userDetails.split('|')[13],
                contact: userDetails.split('|')[14]
            },
            notes: {
                "IFSC Code": userDetails.split('|')[19] || "",
                "Client Id": userDetails.split('|')[11],
                "Product": userDetails.split('|')[21],
                "Bank Name": userDetails.split('|')[20],
                "Bank Account Number": userDetails.split('|')[4]
            },
            theme: {
                color: themecolor
            },

            handler: function (response) {
                alert("Payment successful! Payment ID: " + response.razorpay_payment_id);
            },


            modal: {
                ondismiss: function () {
                    alert("Payment process was canceled or interrupted.");
                }
            }
        };

        const razorpayInstance = window.Razorpay(options);
        razorpayInstance.open();

        razorpayInstance.on('payment.failed', function (response) {
            alert("Payment failed: " + response.error.description);
        });
    }




    const handleAddFunds = async (source) => {
        let upi_intent = false;
        let bAPP_UPI_INTENT_RAZORPAY = getAppInfoData(APP_INFO_PARAMS.APP_UPI_INTENT_RAZORPAY, appInfo);
        if ((bAPP_UPI_INTENT_RAZORPAY && (bAPP_UPI_INTENT_RAZORPAY.toString().toUpperCase() == "TRUE" ||
            bAPP_UPI_INTENT_RAZORPAY.toString().toUpperCase() == "ON"))) {
            upi_intent = true;
        }
        try {
            if (source == 'marketMain' || source == 'ipoMain') {   // BT-113015 Require 24*7 IPO order placement, Samadhan S, 10/06/2024
                if (modals['UPI_MODAL']) {
                    //let regexUPIIDobj = new RegExp(/^([a-zA-Z0-9]){5,30}([@]){1}([a-zA-Z]){3,30}?$/);
                    if (UPIID.trim() == '') {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please Enter UPI ID` }));
                    }
                } else {
                    dispatch(handleModal([{ "UPI_MODAL": false }]));
                    //this.inputId.setFocus();
                    //   make sure input is focused --Shuaib Peerjade
                    //   setTimeout(() => {
                    //     this.setFocusOnInput();
                    //   }, 100);
                    //   make sure input is focused --Shuaib Peerjade
                }
            } else {
                if (!activeMarket) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please select the product` }));
                }

                if (!Number(addFunds?.addAmount)) {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: "Please add amount " }));
                }



                // conditions for upi ---start 
                // if (maxAmount && this.BankingOption == this.UPIBankingOptionTabCode){
                //     if ((this.addAmount) > parseFloat(this.maxAmount)) {
                //         this.toastCtrl.showAtBottom('Please enter Amount between ' + this.MinUPIAmount + ' to ' + this.maxAmount);
                //         return false;
                //     }
                // }
                // This block is for upi ---End

                if (addFundOption == 'Net Banking') {
                    if (Number(addFunds?.addAmount) > Number(maxAmount_add) || Number(addFunds?.addAmount) <= 0) {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please enter Amount between ${minAmount} to ${maxAmount_add}` }));
                    }
                }

                if (addFundOption == 'NEFT') {
                    handleNEFTAddButton();
                } else {
                    let selMappedBank = arrProductWiseUPIDetails[0];
                    if (addFundOption == "UPI" || addFundOption == "Net Banking") {
                        if (Object.keys(selectedBank)?.length <= 0) {
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `No linked bank account found` }));
                        }
                        if (addFundOption == "Net Banking") {
                            selMappedBank = arrProductWiseUPIDetails[0];
                            if (!selMappedBank) {
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: ` Please select the Gateway` }));
                            }
                        }

                    }

                    if (addFundOption == 'UPI' && !upi_intent) {
                        if (modals['UPI_MODAL']) {
                            //let regexUPIIDobj = new RegExp(/^([a-zA-Z0-9]){5,30}([@]){1}([a-zA-Z]){3,30}?$/);
                            if (this.UPIID.trim() == '') {
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please Enter UPI ID` }));
                            }
                        } else {
                            dispatch(handleModal([{ "UPI_MODAL": false }]));
                            //this.inputId.setFocus();
                            //   make sure input is focused --Shuaib Peerjade
                            //   setTimeout(() => {
                            //     this.setFocusOnInput();
                            //   }, 100);
                            //   make sure input is focused --Shuaib Peerjade
                        }
                    }


                    if (addFundOption == "UPI") {
                        if (selectedBank.sMasterBankId == "CBIHOLD" && ModeOption == 0) {
                            setAddFunds({ ...addFunds, addAmount: 0 });
                        }
                        else if (selectedBank.sMasterBankId == "UCOHOLDSYNC") {
                            setAddFunds({ ...addFunds, addAmount: 0 });
                        }
                        //let strAmount;
                        if (selectedBank.sMasterBankId == "CBIHOLD" && ModeOption == 0) {
                            setAddFunds({ ...addFunds, addAmount: 0 });
                        }
                        else if (selectedBank.sMasterBankId == "UCOHOLDSYNC") {
                            setAddFunds({ ...addFunds, addAmount: 0 });
                        }
                        else {
                            if ((addFunds.addAmount) < nMinAmount) {
                                dispatch(toastConfig({ autoDismiss: true, show: true, message: `The minimum amount can be transferred is Rs.${minAmount}` }));
                            }
                            //strAmount = (this.addAmount);
                        }
                    }

                    if (addFundOption == "Net Banking") {
                        if (Number(addFunds?.addAmount) < Number(minAmount)) {
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: `The minimum amount can be transferred is Rs.${minAmount}` }));
                        }
                    } else if (addFundOption == 'DC') {
                        // if (this.gatewaySelected == undefined || this.gatewaySelected == '') {
                        //     this.toastCtrl.showAtBottom('Please select the Gateway');
                        //     return false;
                        // }
                    }


                    // if (this.BankingOption == this.UPIBankingOptionTabCode && this.PGUPIGateway.length > 0) {
                    //     this.PGUPIGateway.forEach(element => {
                    //         if (element.sMappedBankId == this.SelectedUPIGateway) {
                    //             selMappedBank = element;
                    //         }
                    //     });
                    // }
                    // else if (this.BankingOption == 'DC') {
                    //     this.gatewayList.forEach(element => {
                    //         if (element.sMasterBankId == this.gatewaySelected) {
                    //             selMappedBank = element;
                    //         }
                    //     });
                    // }

                    let strBankId = selMappedBank.sBankId;
                    let strMappedBankId = selMappedBank.sAggregatorBankId || '';
                    let strAgencyId = selMappedBank.sMerchantId;
                    let strBlockThirdParty = selMappedBank.nBlockThirdParty;
                    let strBankGroupId = selMappedBank.nGroupId;
                    // let strBankAccountNo = "0";
                    let strRef = "0";
                    let strAcctCustId = "";

                    if (addFundOption == "UPI") {
                        strBlockThirdParty = "1";
                    }

                    if (strMappedBankId.indexOf('-') != -1) {
                        let arrBank = strMappedBankId.split('-');
                        strMappedBankId = arrBank[1];
                    }


                    if (addFundOption == 'Net Banking' || addFundOption == "UPI") {
                        if (strBlockThirdParty == "1") {
                            // if (this.BankAccSelected == undefined) {
                            //   this.toastCtrl.showAtBottom('Please select linked account.');
                            //   return false;
                            // }

                            let selBankAcc

                            bankAccList.forEach(element => {
                                if (element.sAccountNo == selectedBank.sAccountNo) {
                                    selBankAcc = element;
                                }
                            });
                            //strBankAccountNo = selBankAcc.sAccountNo;
                            strRef = selBankAcc.sRef;
                            strAcctCustId = selBankAcc.sCustomerId;
                        }
                    }

                    // if (this.BankingOption == 'DC') {
                    //     // strBankAccountNo = "0";
                    //     strRef = "0";
                    //     strAcctCustId = "";
                    // }

                    let strProductId = activeMarket.sProductId;
                    let strProductName = activeMarket.sProductName;
                    let strProduct = "WAVE";
                    let strManagerId = objLoginSession?.data?.others?.managerIP ? objLoginSession?.data?.others?.managerIP : "Odindemo.63moons.com";
                    if (strAgencyId != '')
                        strAgencyId = strAgencyId.replace(" ", ",");
                    let strBankBrokerCode = "";
                    if (strBankId == 'BOMHOLD' && strBankBrokerCode == '') {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please Enter UPI ID` }));
                    }
                    /*  Added on 29062010 for minimum amount validation for ATOM PG  */
                    if ((strBankId == 'ATOMPG' || strBankId == 'ATOMPGDC') && addFunds?.addAmount < 50) // Currently amount set is 50
                    {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `The minimum amount can be transferred is Rs.50` }));
                    }
                    if (strBankId == 'HDFCS2S' && strAcctCustId == '') {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: 'Customer Id for the selected Bank Account is blank' }));
                    }

                    //  Need to ask dheeraj as PG_TRANSACTION_CHARGE_INCLUDED is declared "OFF" so it will never run
                    // if (strBankId == 'ATOMPG' || strBankId == 'BILL' || strBankId.toUpperCase() == 'TECHVIEW1') {
                    //     if (this.PG_TRANSACTION_CHARGE_INCLUDED == "ON") {
                    //         this.addAmount = (this.addAmount) + (this.PG_TRANSACTION_CHARGE);
                    //     }
                    // }
                    // Need to ask dheeraj as PG_TRANSACTION_CHARGE_INCLUDED is declared "OFF" so it will never run

                    let strQS = "BankID=" + encodeURIComponent(strBankId);
                    strQS += "&AgencyID=" + encodeURIComponent(strAgencyId);
                    strQS += "&ProductId=" + encodeURIComponent(strProductId);
                    strQS += "&ProductName=" + encodeURIComponent(strProductName);
                    strQS += "&Amount=" + encodeURIComponent(addFunds?.addAmount.toString());
                    strQS += "&BankGroupId=" + encodeURIComponent(strBankGroupId);
                    // strQS += "&UserID=" + encodeURIComponent(strUserId);
                    // strQS += "&UserGroupID=" + encodeURIComponent(strUserGroupId);
                    strQS += "&Product=" + encodeURIComponent(strProduct);
                    strQS += "&ManagerId=" + encodeURIComponent(strManagerId);
                    strQS += "&BankAcctNo=";
                    strQS += "&BlockThirdParty=" + encodeURIComponent(strBlockThirdParty);
                    strQS += "&BankBrokerCode=" + encodeURIComponent(strBankBrokerCode);
                    strQS += "&AccCustid=" + encodeURIComponent(strAcctCustId);
                    strQS += "&MappedBankId=" + encodeURIComponent(strMappedBankId);
                    strQS += "&Ref=" + encodeURIComponent(strRef);


                    if (addFundOption == 'UPI') {
                        let UPIValueHeader = "";
                        if (atomValueHeader?.length > 0) {
                            UPIValueHeader = atomValueHeader;
                        }
                        else {
                            UPIValueHeader = ATOM_VALUE_HEADER;
                        }
                        strQS += '&UPIID=' + encodeURIComponent(addFunds?.UPIId);  //"&UPIID="
                    }


                    if (ModeOption == 0) {
                        if (strQS.indexOf("&HoldRelease") == -1) {
                            strQS += "&HoldRelease=HOLD";
                        }
                    } else if (ModeOption == 1) {
                        if (strQS.indexOf("&HoldRelease") == -1) {
                            strQS += "&HoldRelease=RELEASE";
                        }
                    }

                    if (strBankId == PAYTM || strBankId == PAYU) {
                        var strBankCode = selMappedBank.sAggregatorBankId;
                        strBankCode = strBankCode.substring(strBankCode.indexOf('-') + 1);
                        strQS += "&BankCode=" + encodeURIComponent(strBankCode);
                    }


                    //BT-108636 && BT-108655 && BT-108654 && BT-108631 :  PAYU NET BANKING INTEGRATION && PAYU UPI INTEGRATION && PAYTM UPI INTEGRATION && PAYTM NET BANKING INTEGRATION : RAJENDRA SIRVI 14/07/2023 <End>
                    let MappedBankId = "";
                    let strMappedBankValue = '';
                    let req = { url: netNetUrl };
                    let netNetPGLink = getDyanmicURL(req, objLoginSession);
                    if (addFundOption != "UPI") {
                        if (addFundOption == 'Net Banking')
                            strMappedBankValue = arrProductWiseUPIDetails[0]?.sBankId;
                        else
                            strMappedBankValue = '';//this.GatewaySelected.sBankId;
                        MappedBankId = selMappedBank.sMasterBankId;
                    }
                    //Norwin D <BT-90979> <Implementation of Two Factor Authentication <> Wave 2.0>
                    setEncryptLocalStorage("LAST_FUNDS_ADD" + '_' + objLoginSession?.data?.user_id, addFunds?.addAmount);
                    // if (MappedBankId == clsConstants.C_S_BOM_BANKID || this.SelectedUPIGateway == this.UPIRazorpayBankId) {
                    //   console.log("Opening Bank URL ");
                    //   try {
                    //     let openwindowobj: any;
                    //     if (this.platform.is("ios")) {
                    //       openwindowobj = this.iab.create(this.netNetPGLink + strUrl, '_blank', 'clearsession=yes,clearcache=yes,location=no,hideurlbar=yes');
                    //     } else{
                    //       openwindowobj = this.iab.create(this.netNetPGLink + strUrl, '_blank', 'clearsession=yes,clearcache=yes,location=yes');
                    //     } 
                    //     clsGlobal.User.fundsDetails = [];
                    //     this.navParamService.myParam = true; 
                    //     this.trnResult = "";
                    //   }
                    //   catch (e) {
                    //     //Global.LogManager.WriteLog('Exception Occured 001-00-622885/001-00-624771/001-00-624605' + e.message, 'Error for InAppBrowser open', 'pg_ToBrokerAccount.js', '');
                    //   }
                    // } 
                    // else 
                    //{
                    let _PaymentGatewayURL;
                    //RAJENDRA S Intent based Razorpay transaction changes <S>


                    // make it true if you want to use razorpay --start
                    let bAPP_UPI_INTENT_RAZORPAY = false;
                    // make it true if you want to use razorpay --end

                    // let bAPP_UPI_INTENT_RAZORPAY = getAppInfoData(APP_INFO_PARAMS.APP_UPI_INTENT_RAZORPAY, appInfo);
                    if (bAPP_UPI_INTENT_RAZORPAY && (bAPP_UPI_INTENT_RAZORPAY.toString().toUpperCase() == "TRUE" ||
                        bAPP_UPI_INTENT_RAZORPAY.toString().toUpperCase() == "ON")) { //BT-108636 && BT-108655 && BT-108654 && BT-108631 :  PAYU NET BANKING INTEGRATION && PAYU UPI INTEGRATION && PAYTM UPI INTEGRATION && PAYTM NET BANKING INTEGRATION : RAJENDRA SIRVI 14/07/2023
                        try {
                            strQS += '&UPI_Intent=Y';
                            _PaymentGatewayURL = createPGURL(strQS, netNetPGLink);
                            const response = await axios.get(_PaymentGatewayURL);
                            const respData = JSON.parse(JSON.stringify(response.data));

                            if (respData.ResponseStatus) {
                                let sOrderId = respData.OrderId;
                                let sMemberId = respData.MemberId;

                                payWithRazorpay(sOrderId, sMemberId, respData.Data);
                            }
                        } catch (error) {
                            dispatch(toastConfig({ autoDismiss: true, show: true, message: "Razorpay Server issue, Please retry !" }));
                        }

                    } else {
                        _PaymentGatewayURL = createPGURL(strQS, netNetPGLink);
                        let openwindowobj = window.open(_PaymentGatewayURL, '_blank', 'width:500,height:200 location=no,hideurlbar=yes,hidenavigationbuttons=yes');
                        dispatch(handleModal([{ "ADD_FUNDS_MODAL": false }]));
                        let timer = setInterval(() => {
                            if (openwindowobj.closed) {
                                dispatch(getPeridiocityWiseBalance());
                                clearInterval(timer);
                                ClearClick();
                            }
                        }, 1000);
                    }

                }


            }
        } catch (error) {
            console.error("error", error);
        }
    };


    const handleSubmitButton = () => {
        let PG_TRANSACTION_CHARGE_INCLUDED = "OFF";
        let PG_TRANSACTION_CHARGES = 50;
        let strProduct = APPLICATION_TYPE;
        let strBankBrokerCode = '';
        let strAcctCustId = '';
        let strMappedBankId = addFunds?.paymentGatWay?.sAggregatorBankId === null ? "" : addFunds?.paymentGatWay?.sAggregatorBankId;
        if (strMappedBankId?.indexOf('-') !== -1) {
            let arrBank = strMappedBankId.split('-');
            strMappedBankId = arrBank[1];
        }
        let strUrl = "ProcessSendData.aspx?BankID=" + addFunds?.paymentGatWay?.sBankId + "&AgencyID=";
        strUrl += addFunds?.paymentGatWay?.sMerchantId + "&ProductId=" + activeMarket.sProductId + "&ProductName=";
        strUrl += activeMarket?.sProductName + "&Amount=" + addFunds.addAmount.toString() + "&BankGroupId=" + addFunds?.paymentGatWay?.nGroupId;
        strUrl += "&UserID=" + objLoginSession?.data?.user_id + "&UserGroupID=" + objLoginSession?.data?.others?.groupId;
        strUrl += "&Product=" + strProduct + "&ManagerId=" + selectedBank?.sManagerIP + "&BankAcctNo=";
        strUrl += selectedBank?.sAccountNo + "&BlockThirdParty=" + addFunds?.paymentGatWay?.nBlockThirdParty + "&BankBrokerCode=";
        strUrl += "" + "&AccCustid=" + selectedBank?.sCustomerId + "&MappedBankId=" + strMappedBankId;



        if (Number(addFunds?.addAmount) > Number(maxAmount_add) || Number(addFunds?.addAmount) <= 0) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Please enter Amount between ${minAmount} to ${maxAmount_add}` }));
        }
        else if (Number(addFunds?.addAmount) < Number(minAmount)) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `The minimum amount can be transferred is Rs.${minAmount}` }));
        }
        else if (Object.keys(selectedBank)?.length <= 0) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `No linked bank account found` }));
        } else if (Object.keys(addFunds?.paymentGatWay)?.length <= 0) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: ` Please select the Gateway` }));
        } else if (addFundOption === "Net Banking") {
            if (selectedBank?.sBankId === 'BOMHOLD' && strBankBrokerCode === '') {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: ` Broker Code is mandatory for Bank of Maharashtra transactions` }));
            }
            else if ((selectedBank?.sBankId === 'ATOMPG' || selectedBank?.sBankId === 'ATOMPGDC') && this.addAmount < 50) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `The minimum amount can be transferred is Rs.50` }));
            }
            else if (selectedBank?.sBankId === 'HDFCS2S' && strAcctCustId === '') {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Customer Id for the selected Bank Account is blank` }));
            }
            else if (selectedBank?.sBankId === 'ATOMPG' || selectedBank?.sBankId === 'BILL' || selectedBank?.sBankId.toUpperCase() === 'TECHVIEW1') {
                if (PG_TRANSACTION_CHARGE_INCLUDED === "ON") {
                    setAddFunds({ ...addFunds, addAmount: (addFunds?.addAmount + PG_TRANSACTION_CHARGES) });
                } else { }
            } else {
                let url = (netNetUrl + "PaymentGateway/" + strUrl);
                let openwindowobj = window.open(url, '_blank', 'width:500,height:200 location=no,hideurlbar=yes,hidenavigationbuttons=yes');
                dispatch(handleModal([{ "ADD_FUNDS_MODAL": false }]));
                let timer = setInterval(() => {
                    if (openwindowobj.closed) {
                        dispatch(getPeridiocityWiseBalance());
                        clearInterval(timer);
                        ClearClick();
                    }
                }, 1000);
            }

        } else if (addFundOption === 'UPI') {
            if (addFunds?.UPIId?.length) {
                const isSatisfyingParameters = _validateUPIId(addFunds?.UPIId);
                if (isSatisfyingParameters) {
                    let url = netNetUrl + "PaymentGateway/" + strUrl + "&UPIID=" + addFunds?.UPIId;
                    let openwindowobj = window.open(url, '_blank', 'width:500,height:80 location=no,hideurlbar=yes,hidenavigationbuttons=yes');
                    // dispatch(toastConfig({ autoDismiss: true, show: true, message: ` Kindly complete you are transaction` }));
                    dispatch(handleModal([{ "ADD_FUNDS_MODAL": false }]));
                    let timer = setInterval(() => {
                        if (openwindowobj.closed) {
                            dispatch(getPeridiocityWiseBalance());
                            clearInterval(timer);
                            ClearClick();
                        }
                    }, 1000);
                } else {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: ` Please Enter correct UPI` }));
                }
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: ` Please Enter UPI` }));
            }
        } else { }

        // dispatch(handleModal([{ "SUCCESS_MODAL": true }]));
        // setAddFunds({ ...addFunds, isNiftTransfer: false });

    };



    const handleNEFTAddButton = () => {
        if (objNEFTConfig?.url?.length) {
            const tempArr = objNEFTConfig?.url.split('?');
            const baseUrl = tempArr[0];
            const paramsUrl = tempArr[1];

            let getNEFTUrl = _createDynamicUrl(paramsUrl, objLoginSession);
            let encParams = 'type=1&enct=' + _EncodeToBase64(getNEFTUrl);
            let NEFTDetailsUrl = `${baseUrl}?${encParams}`;
            window.open(NEFTDetailsUrl);
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `Something went wrong, Kindly contact administrator.` }));
        }
    };

    const handleClose = () => {
        setAddFunds({ ...addFunds, paymentGatWay: {}, UPIId: '', isNiftTransfer: false, addFundOption: '', addAmount: 0 });
        dispatch(handleModal([{ "ADD_FUNDS_MODAL": false }]));
    };



    const handleProductChange = (value) => {
        setActiveMarket(value);
    };

    const handleBankChange = (bankDetails) => {
        setSelectedBank(bankDetails);
    };
    const handUPIChange = (value) => {
        setAddFunds({ ...addFunds, paymentGatWay: value });
    };

    const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    const handleUPIChange = (value) => {
        setAddFunds({ ...addFunds, UPIId: value });
    };


    const handleBankList = () => {
        dispatch(handleModal([{ "BANK_AVAILABLE_MODAL": true }]));
    };
    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
    useEffect(() => {
        // Deepti B. 18/04/2024 Restricted API call on adding fund
        if (!isGuestUser() && modals['ADD_FUNDS_MODAL']) {
            if (availableBankList?.length <= 0) {
                dispatch(getAvailableBankList());
            } else { }
        } else { }
    }, [modals['ADD_FUNDS_MODAL']]);
    //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
    // Hari K : 25-11-2023 : BT-99161 - Breeze - funds-add funds modal-end


    return (
        /*SumitG-08-12-23*/
        <Container fluid className='p-0'>
            <BzModal show={modals['ADD_FUNDS_MODAL']} onHide={handleClose} centered>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            {addFunds.isNiftTransfer ?
                                <Col md={10} className='d-flex justify-content-start align-items-center'>
                                    <div className='font-medium font-size4 color-text'>NEFT Transfer</div>
                                </Col> :
                                <Col md={10} className='d-flex justify-content-start align-items-center add-funds-dropdown-wrapper'>
                                    <Dropdown>
                                        <Dropdown.Toggle as={CustomDropdownToggle}>
                                            <div className='d-flex justify-content-start align-items-center'>
                                                <div className='font-medium font-size3 color-text'>{activeMarket?.sProductName} (Balance: ₹ {_commaFormatter(_kFormatter(parseFloat(activeMarket?.balanceAmount)))})</div>
                                                <div className='icon-20 icon-sort-down icon-dark ms-2'></div>
                                            </div>
                                        </Dropdown.Toggle>
                                        {productWiseBalance && productWiseBalance?.length > 0 ?
                                            <Dropdown.Menu >
                                                {productWiseBalance && productWiseBalance?.length > 0 && productWiseBalance?.map((eachProduct, i) => (
                                                    <Dropdown.Item key={i} onClick={() => { handleProductChange(eachProduct); }} value={eachProduct.sProductId}>{eachProduct?.sProductName} (Balance: ₹{_commaFormatter(_kFormatter(parseFloat(eachProduct?.balanceAmount)))})</Dropdown.Item>
                                                ))}
                                            </Dropdown.Menu>
                                            : null}
                                    </Dropdown>
                                </Col>}
                            <Col md={2} className='d-flex justify-content-end align-items-center'>
                                <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                {addFunds.isNiftTransfer ?
                    <BzModalBody>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col>
                                    <Row className='g-0 alert alert-danger'>
                                        <Col md={1} className='d-flex justify-content-center'>
                                            <div className='icon-20 icon-info icon-light'></div>
                                        </Col>
                                        <Col md={11}>
                                            <div>Go to your Net Banking Portal and add funds to your account. Keep the Transaction Reference No. handy to add in the form below</div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-3'>
                                        <Col className='d-flex justify-content-start'>
                                            <div className='Bzmodalselect-dropdown'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle className='btn-default'>{1}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        <Dropdown.Item>For Equity</Dropdown.Item>
                                                        <Dropdown.Item>For Derivatives</Dropdown.Item>
                                                        <Dropdown.Item>FOR COMMODITIES</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-3'>
                                        <Col>
                                            <div>
                                                <BzInputText className='form-control font-regular color-text' type="text" placeholder="Transaction reference no" max={Number.POSITIVE_INFINITY} />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-3'>
                                        <Col>
                                            <div className='form-control font-regular color-text'>
                                                <BzTextArea placeholder={'Add remarks here if any or copy past the transaction SMS you might have received from thebank....'} className='p-0 form-control form-control-sm font-regular color-text bdr-none resizenone' />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mb-3'>
                                        <Col>
                                            <BzButton className='btn btn-primary btn-block btn-lg d-flex justify-content-center align-items-center' onClick={handleSubmitButton}>Submit</BzButton>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalBody> :

                    <BzModalBody>
                        <Container fluid className='p-0'>
                            <Row className='g-0 d-flex align-items-center'>
                                <Col md={4} className='pe-4'>
                                    <div className='font-medium font-size9 color-text text-wrap'>Add <div className='break-line'>Funds</div></div>
                                </Col>
                                <Col md={8} >
                                    <div className={`input-group align-items-center add-funds-input ${addFundOption === 'NEFT Tranfer' ? "div-disabled" : ""}`}>
                                        <span className='font-medium font-size9 color-text me-1'>&#8377;</span>
                                        <BzInputText type="number" name="add amount" value={addFunds?.addAmount} className='text-start font-size9 p-0 font-medium bdr-none' onChange={(e) => handleOrderInputs(e.target.value)} />
                                    </div>
                                    <div className={`d-flex justify-content-start mt-2 ${addFundOption === 'NEFT Tranfer' ? "div-disabled" : ""}`}>
                                        <div className='chips-wrap'>
                                            <BzChip className='chips outline-chip me-1 cursor-pointer' onClick={() => handleOrderInputs(10000)}>&#8377;10,000</BzChip>
                                            <BzChip className='chips outline-chip me-1 cursor-pointer' onClick={() => handleOrderInputs(50000)}>&#8377;50,000</BzChip>
                                            <BzChip className='chips outline-chip me-1 cursor-pointer' onClick={() => handleOrderInputs(100000)}>&#8377;100,000</BzChip>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            {addFundOption !== "NEFT Tranfer" ?
                                <>
                                    <Row className='g-0 pt-4'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='font-regular font-size3 color-subtext me-2'>Link Account</div>
                                            <div className='d-flex justify-content-start align-items-center add-funds-dropdown-wrapper'>
                                                <Dropdown>
                                                    <Dropdown.Toggle as={CustomDropdownToggle}>
                                                        <div className='d-flex justify-content-start align-items-center'>
                                                            {selectedBank && Object.keys(selectedBank)?.length > 0 ?
                                                                <div className='font-medium font-size3 color-text'>{selectedBank?.sBankId}XXX{selectedBank?.sAccountNo?.slice(-4)}</div>
                                                                : null}
                                                            {arrProductWiseBankAccounts?.length > 1 ?
                                                                <div className='icon-20 icon-sort-down icon-dark ms-2'></div> : null}
                                                        </div>
                                                    </Dropdown.Toggle>
                                                    {arrProductWiseBankAccounts?.length > 1 ?
                                                        <Dropdown.Menu>
                                                            {arrProductWiseBankAccounts?.length > 1 && arrProductWiseBankAccounts?.map((eachBank) => (
                                                                <Dropdown.Item key={eachBank?.sAccountNo} onClick={() => { handleBankChange(eachBank); }} value={eachBank.sAccountNo}>{eachBank?.sBankId}XXX{eachBank?.sAccountNo?.slice(-4)}</Dropdown.Item>
                                                            ))}
                                                        </Dropdown.Menu> : null}
                                                </Dropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row className='g-0 mt-3'>
                                        <Col className='d-flex justify-content-start align-items-center'>
                                            <div className='font-regular font-size3 color-subtext me-2'>Payment Gateway</div>
                                            <div className='d-flex justify-content-start align-items-center add-funds-dropdown-wrapper'>
                                                <Dropdown>
                                                    <Dropdown.Toggle as={CustomDropdownToggle}>
                                                        <div className='d-flex justify-content-start align-items-center'>
                                                            <div className='font-medium font-size3 color-text'>{addFunds?.paymentGatWay?.sMappedBankName}</div>
                                                            {arrProductWiseUPIDetails?.length > 1 ? <div className='icon-20 icon-sort-down icon-dark ms-2'></div> : null}
                                                        </div>
                                                    </Dropdown.Toggle>
                                                    {arrProductWiseUPIDetails?.length > 1 ?
                                                        <Dropdown.Menu >
                                                            <div className=''>
                                                                {arrProductWiseUPIDetails?.length && arrProductWiseUPIDetails?.map((each) => (
                                                                    <Dropdown.Item key={each?.sMappedBankId} onClick={() => handUPIChange(each)} value={each?.sMappedBankId}>{each?.sMappedBankName}</Dropdown.Item>
                                                                ))}
                                                            </div>
                                                        </Dropdown.Menu> : null}
                                                </Dropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                </> : null}
                            <Row className='g-0 mt-3'>
                                <Col className='d-flex justify-content-start align-items-center add-funds'>
                                    {isUPIShow ?
                                        <div className={addFundOption === 'UPI' ? 'addfunds-modal-radio-card active' : 'addfunds-modal-radio-card'} onClick={() => handleAddTransfer("UPI")}>
                                            <input type='radio' className='form-check-input mb-3' value="UPI" checked={addFundOption === 'UPI'} />
                                            <div className='font-medium font-size4 text-wrap'>UPI <div className='break-line'>Apps</div></div>
                                        </div> : null}

                                    <div className={addFundOption === 'Net Banking' ? 'addfunds-modal-radio-card active' : 'addfunds-modal-radio-card'} onClick={() => handleAddTransfer("Net Banking")}>
                                        <input type='radio' className='form-check-input mb-3' value="Net Banking" checked={addFundOption === 'Net Banking'} />

                                        <div className='font-medium font-size4 text-wrap'>Net <div className='break-line'>Banking</div></div>
                                    </div>

                                    {objNEFTConfig?.active ?
                                        <div className={addFundOption === 'NEFT Tranfer' ? 'addfunds-modal-radio-card active' : 'addfunds-modal-radio-card'} onClick={() => handleAddTransfer("NEFT Tranfer")}>
                                            <input type='radio' className='form-check-input mb-3' value="NEFT Tranfer" checked={addFundOption === 'NEFT Tranfer'} />
                                            <div className='font-medium font-size4 text-wrap'>NEFT <div className='break-line'>Transfer</div></div>
                                        </div> : null}
                                </Col>
                            </Row>
                            {  /* Hari K:08-11-2023 :BT-119138:Funds Viev-to show show down time message-start*/}
                            {(addFundOption === "UPI" || addFundOption === "Net Banking") && objDowntime?.IsDownTime ?
                                <Row className='g-0 py-2 mb-2'>
                                    <Col md={1} className='d-flex justify-content-center'>
                                        <div className='icon-16 icon-info icon-negative'></div>
                                    </Col>
                                    <Col md={11}>
                                        <div className='font-regular font-size2 color-error'>{objDowntime?.PGDowntimeMsg}</div>
                                    </Col>
                                </Row>
                                : null}
                            {  /* Hari K:08-11-2023 :BT-119138:Funds Viev-to show show down time message-end*/}
                            {addFundOption === "UPI" || addFundOption === "Net Banking" ?
                                <Row className='g-0 py-2 mb-2'>
                                    <Col className='d-flex justify-content-center'>
                                        <div className='font-regular font-size2 color-text'><span>Note:</span>{fundsConfig?.FAdisclaimer}</div>
                                    </Col>
                                </Row> : null}
                            {addFundOption === "UPI" ?
                                <Row className='g-0 mt-4'>
                                    <Col md={6} className='d-flex flex-column mb-4'>
                                        <div className='font-regular font-size3 color-text me-2 mb-1'>Enter UPI ID</div>
                                        <BzInputText type='text' placeholder="UPI ID here..." className='form-control-sm font-regular color-subtext' onChange={(e) => handleUPIChange(e.target.value)} />
                                    </Col>
                                    <BzButton className='btn btn-md btn-primary btn-block' disabled={isSatisfiedAllparameters} onClick={handleAddFunds}>Adds Funds</BzButton>
                                </Row>
                                : addFundOption === "Net Banking" ?
                                    <>
                                        <Row className='g-0 mt-4'>
                                            <Col md={12}>
                                                {/* <div className='font-regular font-size3 color-text me-2'>Choose Mode</div>
                                            <div>
                                                <Row className='g-0 mb-4'>
                                                    <Col md={4} className='d-flex justify-content-start align-items-center'>
                                                        <input type='radio' className='form-check-input me-2' checked value="holdFunds" onClick={(e) => handleNetBanking(e.target.value)} />
                                                        <div className='font-medium font-size4 color-text pt-1'>Hold Funds</div>
                                                    </Col>
                                                    <Col md={4} className='d-flex justify-content-start align-items-center'>
                                                        <input type='radio' className='form-check-input me-2' value="ReleaseFunds" onClick={(e) => handleNetBanking(e.target.value)} />
                                                        <label className='font-medium font-size4 color-text pt-1'>Release Funds</label>
                                                    </Col>
                                                </Row>
                                            </div> */}
                                                {/* <div>
                                                <BzButton className='btn btn-md btn-primary btn-block' onClick={handleSubmitButton}>{addFunds.netBankMode == "holdFunds" ? "Holds Funds" : "Release Funds"} </BzButton>
                                            </div> */}
                                            </Col>
                                        </Row>
                                        <Row className='g-0 d-flex flex-column'>
                                            <Col className='mb-3'>
                                                <div className='font-medium font-size3 color-text text-center' onClick={handleBankList}><span className='cursor-pointer'>Banks available for Transfer</span></div>
                                            </Col>
                                            <Col>
                                                <div>
                                                    <BzButton className='btn btn-md btn-primary btn-block' disabled={isSatisfiedAllparameters} onClick={handleAddFunds}> Add Funds </BzButton>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                    : addFundOption === "NEFT Tranfer" ?
                                        <Row className='g-0 mt-4'>
                                            <Col>
                                                <Row className='g-0 alert alert-danger'>
                                                    <Col md={1} className='d-flex justify-content-center'>
                                                        <div className='icon-20 icon-info icon-light'></div>
                                                    </Col>
                                                    <Col md={11}>
                                                        <div className='mb-2'>Click on Add Funds below to continue and submit your NEFT details</div>
                                                    </Col>
                                                </Row>
                                                {    /* Hari K:08-11-2023 :BT-119138:Funds Viev-to show show down time message-start*/}

                                                {objDowntime?.IsDownTime ?
                                                    <Row className='g-0 py-2 mb-2'>
                                                        <Col md={1} className='d-flex justify-content-center'>
                                                            <div className='icon-16 icon-info icon-negative'></div>
                                                        </Col>
                                                        <Col md={11}>
                                                            <div className='font-regular font-size2 color-error'>{objDowntime?.PGDowntimeMsg}</div>
                                                        </Col>
                                                    </Row>
                                                    : null}
                                                {    /* Hari K:08-11-2023 :BT-119138:Funds Viev-to show show down time message-end*/}
                                                <Row className='g-0 py-2 mb-2'>
                                                    <Col className='d-flex justify-content-center'>
                                                        <div className='font-regular font-size2'><span>Note:</span>{fundsConfig?.FAdisclaimer}</div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col>
                                                        <BzButton className='btn btn-md btn-primary btn-block' disabled={isSatisfiedAllparameters} onClick={handleAddFunds}>Add Funds</BzButton>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row> : null}
                        </Container>
                    </BzModalBody>
                }

            </BzModal>
            <SuccessModal addFundOption={addFunds?.addFundOption} />
        </Container>

    );
};


export default memo(AddFundsModal);

// Hari K : 20-06-2023 : BT-99161 - Breeze - funds-add funds modal-end